import type { ReactNode } from 'react'

export function ResolutionSection({ children }: { children: ReactNode }) {
  return (
    <section className="space-y-4">
      <div>
        <h3 className="text-base font-semibold leading-[1.5] text-charcoal">Resolution</h3>
        <p className="text-sm leading-[1.5] text-charcoal-50">
          Send a cost estimate, or mark the task if you can&rsquo;t send one.
        </p>
      </div>
      {children}
    </section>
  )
}
